// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input[data-v-34992b3f]{margin-top:27px}.col-md-6[data-v-34992b3f]{padding-left:5px;padding-right:5px}", ""]);
// Exports
module.exports = exports;
